'use strict';

angular.module('ClinicApp').config(function($stateProvider, authorizationProvider) {
  $stateProvider.state('onboard', {
    url: '/onboard/',
    templateUrl: '/views/onboard.html',
    controller: 'OnboardCtrl',
    data: {
      hideNavigation: true,
    },
    resolve: {
      auth: authorizationProvider.requireAuthorizedUser,
      pageTitle: function($pageTitle) {
        $pageTitle.set('Onboarding - Opencare');
      },
    },
  });
});

angular.module('ClinicApp').controller('OnboardCtrl', function($scope, $state) {
  $scope.success = function() {
    $state.go('home');
  };
});
